<template>
	
	<div style="margin-top: 35px;" v-if="tree.length > 0">
		<h5 style="padding: 0; margin: 0;">Package preview</h5>

		<ul class="collection-tree">
			<li class="tree-item" v-for="treeItem in tree" :key="treeItem.name">
				<div class="item-row">
					<span class="icon carret"><i :class="getIcon(treeItem)"></i></span>
					<a @click="openChilds(treeItem)" class="name">{{ treeItem.name }}</a>
					<span class="icon-bar">
						<span><i class="bi bi-unlock"></i></span>
					</span>
				</div>
				
				<ul class="collection-tree nested" v-if="treeItem.active && treeItem.childs">
					<li class="tree-item" v-for="treeItem in treeItem.childs" :key="treeItem.name">
						<div class="item-row">
							<span class="icon carret"><i :class="getIcon(treeItem)"></i></span>
							<a v-if="treeItem.type=='dir'" @click="openChilds(treeItem)" class="name">{{ treeItem.name }} </a>
							<a v-if="treeItem.type=='file' && treeItem.direct" :href="'/assets/' + treeItem.uri" class="name">{{ treeItem.name }} </a>
							<a v-if="treeItem.type=='file' && treeItem.bulk" :href="treeItem.uri" class="name">{{ treeItem.name }} </a>
							<span class="icon-bar">
								<span><i class="bi bi-lock"></i></span>
							</span>
						</div>
						<ul class="collection-tree nested" v-if="treeItem.active && treeItem.childs">
							<li class="tree-item" v-for="treeItem in treeItem.childs" :key="treeItem.name">
							<div class="item-row">
								<span class="icon carret"><i :class="getIcon(treeItem)"></i></span>
								<a target="_blank" :href="'//collector.damp.pef.czu.cz' + treeItem.uri" class="name">{{ treeItem.name }}</a>
								<span class="icon-bar">
									<span><i class="bi bi-unlock"></i></span>
								</span>
							</div>
							</li>
						</ul>
					</li>
				</ul>
			</li>
		</ul>

	</div>

</template>

<script> 
import { useProjectStore } from '../stores/project-store'
import { useCollectionStore } from '../stores/collection-store'
import CollectionService from '../services/collection-service'
import { watch } from '@vue/composition-api/dist/vue-composition-api.js';
import BulkService from '../services/bulk-service';

export default {
	components: {},
	name: 'PackageView',
	props: {
		projectId: [String,Number],
		collectionId: [String,Number],
		col: {},
	},
	data: () => ({
		search: '',
		projects: useProjectStore(),
		collections: useCollectionStore(),
		bulks: new BulkService(),
		project: {},
		collection: {},
		tree: [],
	}),
	mounted: async function() {
		await this.load()
	},
	watch : {
		col: function(o,n) {
			this.load()
		}
	},
	computed: {

	},
	methods: {
		load: async function() {
			let tree = [];
			let loadCol = "";

			if(this.col && this.col.directoryListingLink != "" && loadCol == "") {
				loadCol = this.col.directoryListingLink
				console.log("load", loadCol, this.col.directoryListingLink)
			}


			if(loadCol != null && loadCol != "") {

				let dataset = [];
				let colMgr = new CollectionService()
				colMgr.getCollectionListing(loadCol)
				.then( r => {

					let tmpList = r.data.sort( (a, b) => a.name.toLowerCase() > b.name.toLowerCase() )

					this.tree = [];
					
					this.tree.push( {name: "Collection data", icon: "", active: false, type: "dir", desc: "data", childs: tmpList} );
				} )
			}

			this.tree = tree;

			this.checkBulks();
		},
		openChilds(item) {
			if(!item.active) {
				item.active = false;
			}
			this.$nextTick( () => {
				item.active = !item.active;
			} )
			console.log(item.name, item.active);
		},
		checkBulks: function() {
			
			this.bulks.fetchAll(this.projectId, this.collectionId)
			.then( r => {
				
				let tmpList = [];
				
				if( r.data.count > 0 ) {
					r.data.data.forEach( elm => {
						let fileLink = `https://console.damp.pef.czu.cz/api/v1/projects/${this.projectId}/collections/${this.collectionId}/bulk/${elm.id}`
						tmpList.push( {name: elm.filename, icon: "", active: false, type: "file", desc: "data", bulk: true, uri: fileLink} );
					});
				}

				this.tree.push( {name: "Uploaded data", icon: "", active: false, type: "dir", desc: "data", childs: tmpList} )
			})


		},
		getIcon: function(item) {
			if(item.type == "dir" && !item.icon && item.icon=="") {
				return "bi bi-folder"
			}

			if(item.type == "dir") {
				switch (item.icon) {
					case "dir":
						return "bi bi-folder";
				}
			}

			if(item.type == "file") {
				switch (item.icon) {
					case "jpg":
						return "bi bi-filetype-jpg";
					case "png":
						return "bi bi-filetype-png";
					case "md":
						return "bi bi-filetype-md";
					case "doc":
						return "bi bi-filetype-doc";
					case "docx":
						return "bi bi-filetype-docx";
					case "xls":
						return "bi bi-filetype-xls";
					case "xlsx":
						return "bi bi-filetype-xlsx";
					case "json":
						return "bi bi-filetype-json";
					case "svg":
						return "bi bi-filetype-svg";
					case "txt":
						return "bi bi-filetype-txt";
					case "xml":
						return "bi bi-filetype-xml";
					case "pdf":
						return "bi bi-filetype-pdf";
					case "bin":
						return "bi bi-earmark-binary";
					default:
						return "bi bi-file";

				}
			}
		}
	}
}

</script>
